<template>
  <v-container fluid>
    <v-layout
      row
      justify-start
      wrap
      flat
      class="container flight_description ma-0 pa-0"
    >
			<div class="summaries">
				<v-flex v-if="minimal === true" class="edit_flight" shrink>
					<v-btn @click="showSearchForm()">
						<v-layout xs12 column>
							<v-flex>
								<v-icon>edit</v-icon>
							</v-flex>
							<v-flex v-if="
								showForm === false ||
								(
									active === 2 &&
									ret_date === null
								) ||
								(
									active >= 3
								)
							">
								Edit
							</v-flex>
							<v-flex v-else>
								Hide
							</v-flex>
						</v-layout>
					</v-btn>
				</v-flex>
				<v-flex
					align-self-start
					class="pa-2 mx-2"
					v-if="descriptions[0].desc !== ''"
				>
					<v-container class="summary-depart">
						<v-layout row class="summary-desc">
							<v-flex class="col1">
								<h5>{{ descriptions[0].title }}</h5>
								<div class="text" v-html="descriptions[0].desc"></div>
							</v-flex>
							<v-flex class="col2 text pt-3 ml-1">
								<div class="pax">{{ descriptions[0].pass }}</div>
								<div class="fare" v-show="descriptions[0].fare != ''">
									{{ descriptions[0].fare }} Fare
								</div>
							</v-flex>
						</v-layout>
					</v-container>
				</v-flex>
				<v-flex
					align-self-start
					class="pa-2 mx-2"
					v-show="descriptions[1].desc !== ''"
				>
					<v-container class="summary-return">
						<v-layout row class="summary-desc">
							<v-flex class="col1">
								<h5>{{ descriptions[1].title }}</h5>
								<div class="text" v-html="descriptions[1].desc"></div>
							</v-flex>
							<v-flex class="text pt-3 ml-1 col2">
								<div class="pax">{{ descriptions[1].pass }}</div>
								<div class="fare" v-show="descriptions[1].fare != ''">
									{{ descriptions[1].fare }} Fare
								</div>
							</v-flex>
						</v-layout>
					</v-container>
				</v-flex>
			</div>
      <v-flex
        align-self-center
        justify-end
        text-align-right
        shrink
        class="total text-xs-right accent ma-0 pa-3 white--text"
        v-show="descriptions[2].desc !== ''"
      >
        <h5>{{ descriptions[2].title }}</h5>
        <div class="price" v-html="descriptions[2].desc"></div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Shared from "@/mixins/Shared";

export default {
  name: "FlightSearchDescription",
  props: {
    descriptions: {
      type: Object,
      required: true
    }
  },
  mixins: [Shared],
  computed: {
    minimal() {
      return this.minMode;
    }
  },
	watch:{
  	'$store.state.form_fields.dep_loc'(value, oldValue) {
			this.$store.dispatch("RESET_RETURN_FLIGHTS");
      this.$store.commit("setStepIncomplete", "Return");
  	},
  	'$store.state.form_fields.dest_loc'(value, oldValue) {
			this.$store.dispatch("RESET_RETURN_FLIGHTS");
      this.$store.commit("setStepIncomplete", "Return");
  	}
	}
};
</script>

<style lang="scss" scoped>
@import "@/styles/theme.scss";

.v-card__title {
  font-weight: bold;
}
div.v-card__title {
  background-color: #eaeaea;
  color: #1b355d;
  padding: 6px;
  font-size: 0.95em;
}
div.v-card__text {
  padding: 5px;
  text-align: right;
  font-size: 0.85em;
}
div.v-card__title div.v-card__text {
  padding: 0px;
}
.icon {
  color: $accent;
}
</style>
